// extracted by mini-css-extract-plugin
module.exports = {"heading":"shop-by-shape-component_heading__jaW8o","container":"shop-by-shape-component_container__pnGYM","cards":"shop-by-shape-component_cards__vqZ_e"};